import styled from "styled-components";

export const Styles = styled.div`
  pre {
    margin: 0;
    margin-bottom: 0;
    overflow: visible;
    white-space: break-spaces;
  }
`;
